import { Component } from '@angular/core';
import { AngularFireStorage } from 'angularfire2/storage';
import { AngularFireAuth } from 'angularfire2/auth';
import { ToastController, LoadingController, Loading } from 'ionic-angular';
import { AdminProvider } from '../../providers/admin/admin';

@Component({
  selector: 'delete-users',
  templateUrl: 'delete-users.html'
})
export class DeleteUsersComponent {

  file: File;
  loading: Loading;

  constructor(private fireStorage: AngularFireStorage,
    private adminProvider: AdminProvider,
    private auth: AngularFireAuth,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController) { }

  changeListener($event): void {
    this.file = $event.target.files[0];
  }

  uploadFile() {
    if (this.file) {
      this.presentLoadingCustom();
      this.auth.auth.currentUser.getIdToken(true).then((idToken) => {
        const name = (+new Date()) + '-' + this.file.name;
        var storageRef = this.fireStorage.ref("csvfiles/" + name);
        storageRef.put(this.file).then((file) => {
          file.task.then((uploadTask) => {
            uploadTask.ref.getDownloadURL().then(downloadURL => {
              this.adminProvider.deleteUsers(idToken, downloadURL).toPromise().then(data => {
                this.fireStorage.storage.refFromURL(downloadURL).delete().then(() => {
                  this.presentToast("¡La operación se ha realizado con éxito!");
                  this.file = undefined;
                  //console.log(data);
                  this.loading.dismiss();
                }).catch(error => {
                  this.presentToast("¡Ha ocurrido un error!");
                  //console.log(error);
                  this.loading.dismiss();
                });
              }).catch(error => {
                this.presentToast("¡Ha ocurrido un error!");
                //console.log(error);
                this.loading.dismiss();
              });
            }).catch(error => {
              this.presentToast("¡Ha ocurrido un error!");
              //console.log(error);
              this.loading.dismiss();
            });
          }).catch(error => {
            this.presentToast("¡Ha ocurrido un error!");
            //console.log(error);
            this.loading.dismiss();
          });
        }).catch(error => {
          this.presentToast("¡Ha ocurrido un error!");
          //console.log(error);
          this.loading.dismiss();
        });
      }).catch(error => {
        this.presentToast("¡Ha ocurrido un error!");
        //console.log(error);
        this.loading.dismiss();
      });
    }
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  presentLoadingCustom() {
    this.loading = this.loadingCtrl.create({
      content: `Loading`
    });
    this.loading.present();
  }

}


// WEBPACK FOOTER //
// ./src/components/delete-users/delete-users.ts